<template>
  <SendByEmailDialog :is-open="isDialogOpened"
                     :cancelDisabled="sendArchivesPending"
                     :okLoading="sendArchivesPending"
                     :title="$t('archives.dialogs.ArchivesSendDialog.title', selectedDocuments.length)"
                     @cancel="closeDialog"
                     @send="sendArchives"
  />
</template>

<script>
import { mapActions, mapState } from 'vuex'

import SendByEmailDialog from '@/common/dialogs/SendByEmailDialog.vue'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { ArchivesActionTypes } from '@/store/modules/archives/action_types'

export default {
  name: 'ArchivesSendDialog',
  components: { SendByEmailDialog },
  mixins: [dialogMixin],
  computed: {
    ...mapState('archives', ['selectedDocuments', 'sendArchivesPending']),
    selectedArchivesFilesIds () {
      return this.selectedDocuments.map(doc => doc.id)
    },
  },
  methods: {
    ...mapActions('archives', [ArchivesActionTypes.SEND_ARCHIVES]),
    async sendArchives (emails) {
      if (!emails) return

      try {
        await this.SEND_ARCHIVES({
          params: {
            archivesFilesIds: this.selectedArchivesFilesIds,
            emails: emails,
          },
        })

        toast.success(this.$t('archives.dialogs.ArchivesSendDialog.sendSuccess'))
        this.closeDialog()
      } catch (error) {
        const errorMessage = error.response?.data?.errorCode === 'ERR_INVALID_RIGHTS' ? 'sendInvalidRightsError' : 'sendError'
        toast.error(this.$t(`archives.dialogs.ArchivesSendDialog.${errorMessage}`))
      }
    },
  },
}
</script>
